import { useDataGridTasks } from 'components/data-grid/hooks';
import { GridModel } from './models';
import { usePermissions } from 'hooks/use-permissions';
import { useMemo } from 'react';
import { PermissionKey } from 'services/user-employee-profile-permissions';
import { EmployeePermissions } from 'services/user-employee-profile-permissions';

export const useGridMedicalPrescriptions = () => {
  return useDataGridTasks<GridModel>();
};

interface UseIsAllowToSendProps {
  row: Pick<GridModel, 'ignoreSedPermissions'>;
  permissionKey: PermissionKey<EmployeePermissions>;
}
export const useIsAllowToSend = (options: UseIsAllowToSendProps) => {
  const { row, permissionKey } = options;
  const isAllowToSend = usePermissions(permissionKey)

  return useMemo(() => {
    return row.ignoreSedPermissions ? true : isAllowToSend;
  }, [row.ignoreSedPermissions, isAllowToSend]);
}
